import React from 'react';
import { Redirect } from 'react-router';
import Login from '../components/userAuthentication/Login';
import Sso from '../components/sso';
import VerifyAccount from '../components/userAuthentication/verifyAccount';
import SignUp from '../components/userAuthentication/SignUp';
import ParentSignUp from '../components/userAuthentication/olympiad';
import VerifyOtp from '../components/userAuthentication/olympiad/verifyOtp';
import JuniorSignUp from '../components/userAuthentication/juniorSignin';
import MyCourse from '../components/myCourse';
import CoachCourse from '../components/changeCourse';
import LiveCourse from '../components/changeCourse';
import OnlineCourse from '../components/changeCourse';
import SubmitAssignment from '../components/myCourse/coachCourse/taskList/submitTask.container';
import BuyCourse from '../components/buyCourse';
import TestPage from '../components/assesment/';
import OnBoard from '../components/onBoarding';
import MyDashboard from '../components/dashboard/';
import MyParentDashboard from '../components/parentDashboard';
import Purchase from '../components/purchase';
import PaymentProcess from '../components/purchase/paymentProcess';
import PaymentSuccess from '../components/purchase/paymentSuccess';
import PaymentFailure from '../components/purchase/paymentFailure';
import Profile from '../components/profile';
import Settings from '../components/settings';
import History from '../components/history';
import Logout from '../components/userAuthentication/logout';
import ChildDashboard from '../components/parentDashboard/childDashboard';
import JuniorDashboard from '../components/parentDashboard/juniorDashboard';

export default {
	regularUser: {
		routes: [
			{
				path: '/mydashboard',
				component: <MyDashboard show={true} />,

				exact: true,
			},

			{
				path: '/courses',
				component: <MyDashboard />,
			},
			{
				path: '/coach',
				component: <CoachCourse show={true} />,
			},
			{
				path: '/live',
				component: <LiveCourse show={true} />,
			},
			{
				path: '/online',
				component: <OnlineCourse show={true} />,
			},
			{
				path: '/submitAssignment',
				component: <SubmitAssignment />,
			},

			{
				path: '/onboard',
				component: <OnBoard />,
			},
			{
				path: '/profile',
				component: <Profile />,
			},
			{
				path: '/settings',
				component: <Settings />,
			},
			{
				path: '/history',
				component: <History />,
			},
		],
	},
	parent: {
		routes: [
			{
				path: '/parent/dashboard',
				component: <MyParentDashboard hideSidebar={true} />,
				exact: true,
			},
			{
				path: '/child/dashboard/:id',
				component: <ChildDashboard hideSidebar={true} />,

				exact: true,
			},
		],
	},
	junior: {
		routes: [
			{
				path: '/junior/dashboard',
				component: <JuniorDashboard hideSidebar={true} />,

				exact: true,
			},
		],
	},

	common: {
		routes: [
			{
				path: '/mycourse',
				component: <MyCourse showStatusSideBar={true} />,
			},
			{
				path: '/test',
				component: <TestPage />,
			},
		],
	},
	payment: {
		routes: [
			{
				path: '/buycourse',
				component: <BuyCourse />,
			},
			{
				path: '/purchase',
				component: <Purchase />,
			},
			{
				path: '/paymentprocess',
				component: <PaymentProcess />,
			},
			{
				path: '/paymentsuccess',
				component: <PaymentSuccess />,
			},

			{
				path: '/paymentfailure',
				component: <PaymentFailure />,
			},
		],
	},

	auth: {
		routes: [
			{
				path: '/sso',
				component: () => <Sso />,
			},
			{
				path: '/',
				component: () => <Login />,
				exact: true,
			},
			{
				path: '/verifyuser',
				component: () => <VerifyAccount />,
				exact: true,
			},
			{
				path: '/signup',
				component: () => <SignUp />,
				exact: true,
			},
			{
				path: '/parent/login',
				component: () => <ParentSignUp />,
				exact: true,
			},
			{
				path: '/parent/signup',
				component: () => <ParentSignUp />,
				exact: true,
			},
			{
				path: '/parent/verifyotp',
				component: () => <VerifyOtp />,
				exact: true,
			},
			{
				path: '/junior/signin',
				component: () => <JuniorSignUp />,
				exact: true,
			},
			{
				path: '/logout',
				component: () =>
					localStorage.getItem('token') ? (
						<Logout />
					) : (
						<Redirect to={{ pathname: '/', state: { from: '/logout' } }} />
					),
			},
		],
	},
};
